// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"b89cce12","251":"3ba9c402","348":"3e134c90","364":"e263ca9d","571":"d87ed126"}[chunkId] + ".chunk.js";
};